import React from 'react';
import { NxOrdersStoreProvider } from '@warehouse/quickbase';
import { NxOrders } from '../../../../../libs/title/feature-nx-orders';

function NxOrdersTab() {
	return (
		<NxOrdersStoreProvider>
			<NxOrders />
		</NxOrdersStoreProvider>
	);
}

export { NxOrdersTab };
